import { apiSlice } from './apiSlice';

export type TransactionType = 'Credit' | 'Debit';

export interface CreateTransactionPayload {
  amount: number;
  type: TransactionType;
  transactionCode?: string;
  imageProof?: string;
  bankId?: number;
  upiId?: number;
}

export interface WalletTransaction {
  id: number;
  amount: number;
  status: 'Pending' | 'Confirmed' | 'Failed';
  type: TransactionType;
  transactionCode: string;
  createdAt: string;
  imageProof?: string;
  bank: {
    id: number;
    bankName: string;
    accountType: string;
    accoutnHolder: string;
    accountNumber: string;
    ifsc: string;
    userId: number;
  } | null;
  upi: {
    id: number;
    name: string;
    upi: string;
    userId: number;
  } | null;
  wallet: {
    id: '1';
    amount: '15664.5';
    version: '231';
    createdAt: '2025-12-09T09:26:25.171Z';
    updatedAt: '2025-12-18T13:00:43.103Z';
    userId: 1;
    user: {
      id: 1;
      firstname: 'Akash';
      lastname: 'Saste';
      username: null;
      email: 'akashsaste@gmail.com';
      dialCode: null;
      mobile: null;
      profileImage: null;
      isVerified: false;
      country: 'India';
      status: 'Active';
      createdAt: '2025-12-09T09:26:25.160Z';
      updatedAt: '2025-12-09T09:26:25.160Z';
    };
  };
}

interface HistoryResponse {
  data: WalletTransaction[];
  pagination: {
    totalItems: number;
    limit: number;
    currentPage: number;
    totalPage: number;
  };
}

export type AdminTransactionAction = 'Approved' | 'Rejected';

export const walletTransactionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTransaction: builder.mutation<{ status: string }, CreateTransactionPayload>({
      query: (body) => ({
        url: '/wallet-transactions/create-deposit-withdraw-request',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Transaction'],
    }),

    getTransactionHistory: builder.query<
      HistoryResponse,
      {
        page?: number;
        limit?: number;
        type?: TransactionType;
        status?: WalletTransaction['status'];
      }
    >({
      query: ({ page = 1, limit = 10, type, status }) => ({
        url: '/wallet-transactions/all-deposit-withdraw',
        params: { page, limit, type, status: status },
      }),
      providesTags: ['Transaction'],
    }),

    updateTransactionStatus: builder.mutation<
      { status: string },
      { id: number; action: AdminTransactionAction }
    >({
      query: ({ id, action }) => ({
        url: `/wallet-transactions/${id}`,
        method: 'PATCH',
        body: { type: action },
      }),
      invalidatesTags: ['Transaction'],
    }),
  }),
});

export const {
  useCreateTransactionMutation,
  useGetTransactionHistoryQuery,
  useUpdateTransactionStatusMutation,
} = walletTransactionApi;
